import { useEffect } from "react";
import Typography from "@material-ui/core/Typography";
import useStyles from "../../../styles/Common";
import "../../../styles/common.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchPassenger, initialStatePassenger, } from "../../../../redux/actions/reservations/passenger/fetchPassengerDetail";
import { fetchCruisesByPassenger, initialStateCruiseByPassenger, } from "../../../../redux/actions/reservations/passenger/fetchCruisesByPassenger";
import { Link, useParams } from "react-router-dom";
import { Form, Message, Table as Tab } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import CircularProgress from "@material-ui/core/CircularProgress";
import Divider from "@material-ui/core/Divider";

export default function CruisePassengerList() {
  const classes = useStyles();
  const { t } = useTranslation();
  const { passenger_id } = useParams();
  const passengerDetailState = useSelector(
    (state) => state.passengerDetailReducer
  );
  const cruiseByPassengerState = useSelector(
    (state) => state.cruiseByPassengerReducer
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (passenger_id) {
      dispatch(fetchPassenger(passenger_id));
      dispatch(fetchCruisesByPassenger(passenger_id));
    }
    try {
      window.scroll({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    } catch (error) {
      window.scrollTo(0, 0);
    }
    return () => {
      dispatch(initialStatePassenger());
      dispatch(initialStateCruiseByPassenger());
    };
  }, [dispatch, passenger_id]);

  if (passengerDetailState.fetching || cruiseByPassengerState.fetching) {
    return <CircularProgress />;
  }

  return (
    <>
      {passengerDetailState.error ? (
        <Message negative content={t(passengerDetailState.error)} />
      ) : (
        ""
      )}
      {cruiseByPassengerState.error ? (
        <Message negative content={t(cruiseByPassengerState.error)} />
      ) : (
        ""
      )}
      <div className="ui breadcrumb">
        <Link to="/passengers">
          <div className="active section">{t("passengers_tag")}</div>
        </Link>
        <div className="divider">/</div>
        <div className="active section">
          {passengerDetailState.passenger.first_name}{" "}
          {passengerDetailState.passenger.last_name}
        </div>
      </div>
      <br></br>
      <br></br>
      <br></br>

      <Form>
        <Form.Group>
          <Form.Field className="w-full">
            <Tab structured textAlign="left" verticalAlign="middle">
              <Tab.Body>
                <Tab.Row>
                  <Tab.Cell>
                    <span
                      style={{
                        color: "#2185D0",
                        fontSize: "20px",
                        fontWeight: "800",
                      }}
                    >
                      {passengerDetailState.passenger.last_name}{" "}
                      {passengerDetailState.passenger.first_name}{" "}
                    </span>
                  </Tab.Cell>
                  <Tab.Cell>
                    <span className="detail_passenger">{t(passengerDetailState.passenger.identification_type)}: </span>{" "}
                    {passengerDetailState.passenger.identification}{" "}
                  </Tab.Cell>
                  <Tab.Cell>
                    <span className="detail_passenger">
                      {t("passenger_search_nationality")}:{" "}
                    </span>{" "}
                    {t(passengerDetailState.passenger.country)}
                  </Tab.Cell>
                </Tab.Row>
                <Tab.Row>
                  <Tab.Cell>
                    <span className="detail_passenger">
                      {t("gender_title")}:{" "}
                    </span>{" "}
                    {t(passengerDetailState.passenger.gender)}
                  </Tab.Cell>
                  <Tab.Cell>
                    <span className="detail_passenger">
                      {" "}
                      {t("passenger_search_age")}:{" "}
                    </span>{" "}
                    {passengerDetailState.passenger.age}{" "}
                    {t("passenger_search_years_old")}{" "}
                  </Tab.Cell>
                  <Tab.Cell>
                    <span className="detail_passenger">
                      {" "}
                      {t("passenger_email")}:{" "}
                    </span>{" "}
                    {passengerDetailState.passenger.email}
                  </Tab.Cell>
                </Tab.Row>
              </Tab.Body>
            </Tab>
          </Form.Field>
        </Form.Group>
      </Form>
      <div>
        <Typography className='my-5' variant="h6">
          {t("cruises_tag")}
        </Typography>
        <Divider variant="middle" />
        <div className="flex flex-col">
          <div className="grid grid-cols-7 font-semibold bg-sky-700 text-white">
            <p className="p-2">{t("cruise_code")}</p>
            <p className="p-2">{t("cruise_yacht")}</p>
            <p className="p-2 flex flex-col">{t("cruise_startDate")}<span className=" text-white  font-sans text-[11px]">(dd-mm-yyyy)</span></p>
            <p className="p-2 flex flex-col">{t("cruise_endDate")}<span className="text-white font-sans text-[11px]">(dd-mm-yyyy)</span></p>
            <p className="p-2">{t("cruise_name")}</p>
            <p className="p-2">{t("cruise_itinerary")}</p>
            <p className="p-2">{t("cabin_cabin")}</p>
          </div>
          <div className="flex flex-col space-y-3">
            {cruiseByPassengerState.cruises.map((cruise) => (
              <div className="border">
                <div className="grid grid-cols-7 border border-b-1 font-semibold bg-slate-500/20">
                  <p className="p-2">{cruise.code}</p>
                  <p className="p-2">{cruise.yacht}</p>
                  <p className="p-2">{cruise.start_date_format}</p>
                  <p className="p-2">{cruise.end_date_format}</p>
                  <p className="p-2">{cruise.name}</p>
                  <p className="p-2">{cruise.itinerary}</p>
                  <p className="p-2">{cruise.cabin}</p>
                </div>
                <div className="grid grid-cols-7 border border-b-1">
                  <p className="p-2">{t("passenger_marital_satatus")}:{" "}{t(cruise.marital_status)}</p>
                  <p className="p-2">TCT:{" "}{cruise.tct ? 'Si' : 'No'}</p>
                  <p className="p-2">GPS:{" "}{cruise.gps ? 'Si' : 'No'}</p>
                  <p className="p-2">{t("passenger_vegetarian")}:{" "}{cruise.vegetarian ? 'Si' : 'No'}</p>
                  <p className="p-2">{t("passenger_glutenFree")}:{" "}{cruise.gluten_free ? 'Si' : 'No'}</p>
                  <p className="p-2"></p>
                  <p className="p-2"></p>
                </div>
                {cruise.feed !== "" && (
                  <div key={`${cruise.id}-feed`} className="grid grid-cols-7 p-2 border border-b-1">
                    <p className="col-span-1 font-semibold">{"Alimentación - Bebidas:"}</p>
                    <p className="col-span-6">{cruise.feed}</p>
                  </div>
                )}
                {cruise.medical_information !== "" && (
                  <div key={`${cruise.id}-medical_information`} className="grid grid-cols-7 p-2 border border-b-1" >
                    <p className="col-span-1 font-semibold">{"Información médica y alergias:"}</p>
                    <p className="col-span-6">{cruise.medical_information}</p>
                  </div>
                )}
                {cruise.rent_wetsuits !== "" && (
                  <div key={`${cruise.id}-rent_wetsuits`} className="grid grid-cols-7 p-2 border border-b-1">
                    <p className="col-span-1 font-semibold">{"Renta wetsuits - aletas:"}</p>
                    <p className="col-span-6">{cruise.rent_wetsuits}</p>
                  </div>
                )}
                {cruise.special_requirements !== "" && (
                  <div key={`${cruise.id}-special_requirements`} className="grid grid-cols-7 p-2 border border-b-1">
                    <p className="col-span-1 font-semibold">{"Requirimientos especiales:"}</p>
                    <p className="col-span-6">{cruise.special_requirements}</p>
                  </div>
                )}
                {cruise.notes !== "" && (
                  <div key={`${cruise.id}-notes`} className="grid grid-cols-7 p-2 border border-b-1">
                    <p className="col-span-1 font-semibold">{"Notas vuelo:"}</p>
                    <p className="col-span-6">{cruise.notes}</p>
                  </div>
                )}
                {cruise.transfer_notes !== "" && (
                  <div key={`${cruise.id}-notes`} className="grid grid-cols-7 p-2 border border-b-1">
                    <p className="col-span-1 font-semibold">{"Notas traslados:"}</p>
                    <p className="col-span-6">{cruise.transfer_notes}</p>
                  </div>
                )}
                {cruise.double_bed && (
                  <div key={`${cruise.id}-notes`} className="grid grid-cols-7 p-2 border border-b-1">
                    <p className="col-span-1 font-semibold">{"Cama matrimonial:"}</p>
                    <p className="col-span-6">{"SI"}</p>
                  </div>
                )}
                {cruise.family_bed && (
                  <div key={`${cruise.id}-notes`} className="grid grid-cols-7 p-2 border border-b-1">
                    <p className="col-span-1 font-semibold">{"Cabina familiar:"}</p>
                    <p className="col-span-6">{"SI"}</p>
                  </div>
                )}
                {cruise.canceled === 1 && (
                  <div key={`${cruise.id}-cancellation`} className="grid grid-cols-7 p-2 border border-b-1">
                    <p className="col-span-1 font-semibold">{t("space_cancelation_reason")} :</p>
                    <p className="col-span-6">{cruise.date_cancellation + ' / ' + cruise.reason_cancellation}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
